import { createContext, useSyncExternalStore } from 'react';

// The server and the first hydration pass must see the same public state.
// Browser-only preferences become visible immediately after hydration, without
// replacing or clearing the customer's saved cart.
const subscribe = () => () => {};
export function useClientReady() {
  return useSyncExternalStore(subscribe, () => true, () => false);
}

export const InitialRenderTime = createContext<number | undefined>(undefined);
